export default __webpack_public_path__ + "static/media/user_Icon.625d0b81.svg";